module.exports = {
  require:
    ngModel: 'ngModel'
  controller: require('./salon-type-selector.ctrl')
  template: require('./salon-type-selector.pug')()
}
